import { render, staticRenderFns } from "./StockItemsTableExpandedCard.vue?vue&type=template&id=b03ef598&"
import script from "./StockItemsTableExpandedCard.vue?vue&type=script&lang=ts&"
export * from "./StockItemsTableExpandedCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports